import { useState } from "react";
import { CustomerData } from "src/shared/services/interfacev2";

export const useCustomerDialogs = () => {
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerData | null>(null);
  const [isEditOpen, setEditOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [isAddOpen, setAddOpen] = useState(false);

  const openEdit = (customer: CustomerData) => {
    setSelectedCustomer(customer);
    setEditOpen(true);
  };

  const openDelete = (customer: CustomerData) => {
    setSelectedCustomer(customer);
    setDeleteOpen(true);
  };

  return {
    selectedCustomer,
    isEditOpen,
    isDeleteOpen,
    isAddOpen,
    openEdit,
    openDelete,
    openAdd: () => setAddOpen(true),
    closeEdit: () => setEditOpen(false),
    closeDelete: () => setDeleteOpen(false),
    closeAdd: () => setAddOpen(false),
    resetSelection: () => setSelectedCustomer(null),
  };
};
